import { render, staticRenderFns } from "./MandatoryPublicDisclosure.vue?vue&type=template&id=56ab8a5e&scoped=true"
import script from "./MandatoryPublicDisclosure.vue?vue&type=script&lang=js"
export * from "./MandatoryPublicDisclosure.vue?vue&type=script&lang=js"
import style0 from "./MandatoryPublicDisclosure.vue?vue&type=style&index=0&id=56ab8a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab8a5e",
  null
  
)

export default component.exports